<template>
  <div class="template-type">
    <div class="images">
      <div v-show="values.saved" class="settings" :data-testid="testId('settings')" @click="clickSettings()" v-b-toggle.template-sidebar><img src="@img/icons-settings-gray.svg" alt="Settings"></div>
      <div class="icon"><img :src="iconImage" class="icon" alt="Settings"></div>
    </div>
    <div>
      <div class="Template-item-title">{{ title }}</div>
      <div class="Template-item-description">
        <slot></slot>
      </div>
    </div>
    <div class="button-bg" :class="{ disabled: showSpinner }" @click="applyTemplate()">
      <div class="label">
        <img class="icon-image" :src="buttonImage" alt="(new)" :data-testid="testId('apply')"> {{ buttonText }}
      </div>
    </div>
  </div>
</template>

<script>
import TemplateBase from '@cmp/shared/template_base.vue';

export default {
  extends: TemplateBase,
  props: [ "tslot", "icon", "title", "values" ],
  data: function() {
    return {
      showSpinner: false
    }
  },
  computed: {
    buttonText: function() {
      return this.values.saved ? "Apply Template" : "Configure";
    },
    buttonImage: function() {
      if (this.values.saved) {
        return require("@img/icons-new.svg");
      } else {
        return require("@img/icons-settings-blue.svg");
      }
    },
    iconImage: function() {
      if (this.showSpinner) {
        return require("@img/spinner.svg");
      } else {
        return require("@img/" + this.icon);
      }
    }
  },
  methods: {
    testId: function(suffix) {
      return (this.tslot ? "template-" + this.tslot + "-" + suffix : "");
    },
    applyTemplate: function() {
      const vm = this;

      if (vm.showSpinner) return;
      vm.showSpinner = true;
      vm.applyTemplateSlot(vm.tslot).then(function() { vm.showSpinner = false; });
    },
    clickSettings: function() {
      this.$bvModal.hide("template-modal");
      if (this.values) {
        this.$root.$refs.templateSidebar.loadSidebar(this.values);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/packs/application.scss';

div.disabled {
  background-color: lightgray !important;
  cursor: not-allowed !important;
}

img.icon-image {
  width: 0.75rem;
  height: 0.75rem;
  margin-bottom: 0.2rem;
  object-fit: contain;
}

.Template-item-title {
  margin: 0.25rem 0 0.25rem;
  font-family: SFPro;
  font-size: 1rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}

.Template-item-description {
  margin: 0.25rem 0 1rem;
  font-family: SFPro;
  font-size: 0.75rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}

.template-type {
  display: flex;
  flex-direction: column;
  align-content: stretch;
  justify-content: space-between;

  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 1px 8px 2px rgba(0, 0, 0, 0.07);

  .images {
    width: 100%;

    .settings {
      position: absolute;
      margin-left: 0.2rem;
      width: 10%;
    }

    .icon {
      img.icon {
        width: 2rem;
        margin-left: auto;
        margin-right: auto;
        display: block;
      }
    }
  }

  .button-bg {
    width: 90%;
    height: 2rem;
    border-radius: 4px;
    border: solid 1px #0078ff;
    background-color: $white;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;
  }

  .label {
    white-space: nowrap;
    height: 0.875rem;
    margin: 0.5rem 0;
    display: block;
    font-family: SFPro;
    font-size: 0.75rem;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: $bright-blue;
  }
}
</style>
